import { useCallback, useRef } from 'react';

/**
 * Swallows a repeat click landing within `windowMs` of the one before it.
 *
 * A ref, not state: the repeat tap fires before React commits, so a state-driven
 * guard is always stale. `reset` reopens the window for a follow-up that is
 * deliberate rather than a fumble.
 */
export function useClickClaim(windowMs: number) {
  const lastClaimRef = useRef(0);

  const tryClaim = useCallback(() => {
    const now = Date.now();
    if (now - lastClaimRef.current < windowMs) return false;
    lastClaimRef.current = now;
    return true;
  }, [windowMs]);

  const reset = useCallback(() => {
    lastClaimRef.current = 0;
  }, []);

  return { tryClaim, reset };
}
